import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * DiscountCapsApi - axios parameter creator
 * @export
 */
const DiscountCapsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsCreate: async (DiscountCapAdminToken, options = {}) => {
            const localVarPath = `/v1/DiscountCaps/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DiscountCapAdminToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsDelete: async (id, options = {}) => {
            const localVarPath = `/v1/DiscountCaps/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsGetById: async (id, options = {}) => {
            const localVarPath = `/v1/DiscountCaps/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapQueryRequest} [DiscountCapQueryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsQuery: async (DiscountCapQueryRequest, options = {}) => {
            const localVarPath = `/v1/DiscountCaps/Query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DiscountCapQueryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsUpdate: async (DiscountCapAdminToken, id, options = {}) => {
            const localVarPath = `/v1/DiscountCaps/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DiscountCapAdminToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DiscountCapsApi - functional programming interface
 * @export
 */
const DiscountCapsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DiscountCapsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCapsCreate(DiscountCapAdminToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCapsCreate(DiscountCapAdminToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCapsApi.discountCapsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCapsDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCapsDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCapsApi.discountCapsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCapsGetById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCapsGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCapsApi.discountCapsGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapQueryRequest} [DiscountCapQueryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCapsQuery(DiscountCapQueryRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCapsQuery(DiscountCapQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCapsApi.discountCapsQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discountCapsUpdate(DiscountCapAdminToken, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discountCapsUpdate(DiscountCapAdminToken, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountCapsApi.discountCapsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DiscountCapsApi - factory interface
 * @export
 */
const DiscountCapsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DiscountCapsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsCreate(DiscountCapAdminToken, options) {
            return localVarFp.discountCapsCreate(DiscountCapAdminToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsDelete(id, options) {
            return localVarFp.discountCapsDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsGetById(id, options) {
            return localVarFp.discountCapsGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapQueryRequest} [DiscountCapQueryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsQuery(DiscountCapQueryRequest, options) {
            return localVarFp.discountCapsQuery(DiscountCapQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: PromotionPolicies)
         * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discountCapsUpdate(DiscountCapAdminToken, id, options) {
            return localVarFp.discountCapsUpdate(DiscountCapAdminToken, id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DiscountCapsApi - object-oriented interface
 * @export
 * @class DiscountCapsApi
 * @extends {BaseAPI}
 */
class DiscountCapsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: PromotionPolicies)
     * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCapsApi
     */
    discountCapsCreate(DiscountCapAdminToken, options) {
        return DiscountCapsApiFp(this.configuration).discountCapsCreate(DiscountCapAdminToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: PromotionPolicies)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCapsApi
     */
    discountCapsDelete(id, options) {
        return DiscountCapsApiFp(this.configuration).discountCapsDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: PromotionPolicies)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCapsApi
     */
    discountCapsGetById(id, options) {
        return DiscountCapsApiFp(this.configuration).discountCapsGetById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: PromotionPolicies)
     * @param {DiscountCapQueryRequest} [DiscountCapQueryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCapsApi
     */
    discountCapsQuery(DiscountCapQueryRequest, options) {
        return DiscountCapsApiFp(this.configuration).discountCapsQuery(DiscountCapQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: PromotionPolicies)
     * @param {DiscountCapAdminToken} [DiscountCapAdminToken]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCapsApi
     */
    discountCapsUpdate(DiscountCapAdminToken, id, options) {
        return DiscountCapsApiFp(this.configuration).discountCapsUpdate(DiscountCapAdminToken, id, options).then((request) => request(this.axios, this.basePath));
    }
}

export { DiscountCapsApi, DiscountCapsApiAxiosParamCreator, DiscountCapsApiFactory, DiscountCapsApiFp };
//# sourceMappingURL=discount-caps-api.js.map
